import { useRouteMatch } from 'quartz-routing/react-router';
import { PLAYLIST_RESULTS_URL_FRAGMENT, PLAYLIST_URL_FRAGMENT, MY_PLAYLISTS_URL_FRAGMENT } from '../../constants/Navigation';
import { FILTER_CONSTS } from '../../constants/TopFilterConstants';
import { usePlaylistProgress } from '../userProgress/userProgressQueries';
export const usePlaylistRemainingItemsAndProgress = playlistId => {
  const {
    playlistProgress,
    playlistProgressLoading
  } = usePlaylistProgress(playlistId);
  const status = playlistProgress ? playlistProgress.status : null;
  const remainingProgressItems = playlistProgress ? playlistProgress.itemsProgress.filter(item => item.status !== 'COMPLETED') : [];
  const remainingProgressItemCount = remainingProgressItems.length;
  const totalProgressItemCount = playlistProgress ? playlistProgress.itemsProgress.length : 0;
  const progressAmount = status === FILTER_CONSTS.STATUSES.COMPLETED ? 1 : status === FILTER_CONSTS.STATUSES.IN_PROGRESS ? (totalProgressItemCount - remainingProgressItemCount) / totalProgressItemCount : 0;
  return {
    remainingProgressItems,
    remainingProgressItemCount,
    totalProgressItemCount,
    progressAmount,
    status,
    playlistProgressLoading
  };
};
export const useIsPlaylistRoute = () => {
  const match = useRouteMatch([PLAYLIST_RESULTS_URL_FRAGMENT, PLAYLIST_URL_FRAGMENT, MY_PLAYLISTS_URL_FRAGMENT]);
  return match ? match.isExact : false;
};